import { CONTACT_INFO } from "../constants/constants";
import { SOCIAL_MEDIA } from "../constants/constants";

import logo from "../images/Logo.svg";

import { SocialLinks } from "../components/SocialLinks";
import { ContactInfo } from "../components/ContactInfo";

interface IProps {
  backgroundColor: string;
}

export const SimpleFooter = ({ backgroundColor }: IProps) => {
  const header = (text: string) => {
    return (
      <h2 className={"mb-6 font-medium text-3xl text-primary-500"}>{text}</h2>
    );
  };

  return (
    <footer className={`${backgroundColor}`}>
      <div
        className={
          "flex flex-col lg:flex-row flex-wrap relative w-2/3 content-center place-self-center lg:items-center lg:justify-between p-16 gap-16 text-xl text-primary-800"
        }
      >
        <div className={"flex flex-col items-center"}>
          <a href={"/"} className={"flex w-40 lg:w-52"}>
            <img src={logo} alt={"logo"} />
          </a>
          <h1 className={"text-primary-500 mb-8"}>
            American Power Washing and Exterior Services LLC
          </h1>
          <SocialLinks
            facebookLink={SOCIAL_MEDIA.FACEBOOK}
            instagramLink={SOCIAL_MEDIA.INSTAGRAM}
            googleLink={SOCIAL_MEDIA.GOOGLE}
          />
        </div>
        <div>
          {header("Contact")}
          <ContactInfo
            phone={CONTACT_INFO.PHONE}
            email={CONTACT_INFO.EMAIL}
            address={CONTACT_INFO.ADDRESS}
          />
        </div>
      </div>
    </footer>
  );
};
